import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices/DomainServicesContext";

import { sessionQueryKeys } from "./sessionQueryKeys";

export interface UseDeleteSessionVariables {
  sessionId: string;
}

export function useDeleteSession() {
  const { sessionService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<void, Error, UseDeleteSessionVariables>({
    mutationFn: ({ sessionId }) => sessionService.deleteSession(sessionId),
    onSuccess: (_void, { sessionId }) => {
      // `removeQueries` matches by key prefix, and `topics(id)`,
      // `files(id)`, and `devices(id)` nest under `detail(id)`, so this one
      // call clears the session's detail, topics, files, and devices caches.
      queryClient.removeQueries({
        queryKey: sessionQueryKeys.detail(sessionId),
      });
      void queryClient.invalidateQueries({
        queryKey: sessionQueryKeys.lists(),
      });
    },
  });
}
